import { render, staticRenderFns } from "./MemberDisconnected.vue?vue&type=template&id=48d2125e&scoped=true"
import script from "./MemberDisconnected.vue?vue&type=script&lang=js"
export * from "./MemberDisconnected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d2125e",
  null
  
)

export default component.exports